<template>
  <v-card flat class="my-10 mx-auto">
    <ValidationObserver ref="observer" v-slot="{ valid }">
      <div
        class="
          d-flex
          variantOne--text
          flex-wrap
          justify-space-between
          align-center
        "
      >
        <p class="col-12 text-h4 variantOne--text pl-12">
          <span>{{ $t("landlord.addUnitToProperty") }}</span>
        </p>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card
            flat
            class="rounded-lg px-md-12 mb-12"
            :key="rerender"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <v-row class="pt-10">
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-text-field
                    outlined
                    v-model="variables.nameEn"
                    class="rounded-lg"
                    :error-messages="errors"
                    :label="$t('landlord.unitNameEn')"
                    ><template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitNameEn") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-text-field
                    outlined
                    v-model="variables.nameAr"
                    :error-messages="errors"
                    class="rounded-lg"
                    :label="$t('landlord.unitNameAr')"
                    ><template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitNameAr") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                    outlined
                    :label="$t('landlord.unitType')"
                    class="rounded-lg"
                    v-model="variables.unitType"
                    item-value="_id"
                    :error-messages="errors"
                    :item-text="$vuetify.rtl ? 'nameAr' : 'nameEn'"
                    :items="unitTypes"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.unitType") }}
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="4" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-text-field
                    readonly
                    outlined
                    :label="$t('landlord.selectRent')"
                    class="rounded-lg"
                    :value="$t(`rentType.${variables.rentType}`)"
                    :error-messages="errors"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.selectRent") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
              <v-col cols="4" class="py-0">
                <ValidationProvider
                  :rules="{ required: true }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    outlined
                    :rules="[validatePaymentDay]"
                    :label="$t('landlord.paymentCollectionDay')"
                    v-model="paymentCollectionDay"
                    class="rounded-lg"
                    :error-messages="errors"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.paymentCollectionDay") }}
                    </template></v-text-field
                  >
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="variables.floorArea"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.areaSqm')"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.areaSqm") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                  <!-- <v-col cols="6" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        class="rounded-lg inputphone"
                        :label="$t('landlord.numberOfunits')"
                        :error-messages="errors"
                        readonly
                        :rules="[checkIfRoomsExhausted]"
                        v-model="variables.numberOfUnits"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.numberOfunits") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-row>
                  <v-col cols="6" md="6" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="variables.oldRent"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.oldRent')"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.oldRent") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="6" md="6" class="py-0">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <v-text-field
                        outlined
                        type="number"
                        v-model="variables.rent"
                        class="rounded-lg inputphone"
                        :error-messages="errors"
                        :label="$t('landlord.rent')"
                        ><template #label>
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t("landlord.rent") }}
                        </template></v-text-field
                      >
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0" v-if="variables.numberOfUnits">
                <v-text-field
                  outlined
                  class="rounded-lg"
                  hide-details="auto"
                  @blur="pushToRoomsArray"
                  :disabled="isRoomsDisabled"
                  :readonly="isMaxNumberOfRoomsTaken"
                  :rules="[isRoomNameAlreadyThere]"
                  :hint="$t('landlord.roomHint')"
                  v-model="stringOfRooms"
                  :placeholder="
                    isMaxNumberOfRoomsTaken
                      ? $t('landlord.maxRoomsEntered')
                      : $t('landlord.addRooms')
                  "
                >
                  <!-- <template v-slot:append-outer>
                        <v-btn
                          :disabled="arrayOfRooms.length === 0"
                          @click="arrayOfRooms = []"
                          text
                          color="primary"
                          class="mt-2">
                          Clear All
                        </v-btn>
                      </template> -->
                  <template
                    v-slot:prepend-inner
                    v-if="arrayOfRooms.length !== 0 && variables.numberOfUnits"
                  >
                    <v-chip-group column>
                      <v-chip
                        v-for="room in arrayOfRooms"
                        close
                        color="primary"
                        @click:close="removeRoomFromArray(room)"
                        :key="room"
                      >
                        {{ room }}
                      </v-chip>
                    </v-chip-group>
                  </template>
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row v-if="arrayOfRooms.length !== 0 && variables.numberOfUnits">
            <v-col class="pt-0">
              <v-chip-group column>
                <v-chip
                v-for="room in arrayOfRooms"
                close
                color="primary"
                @click:close="removeRoomFromArray(room)"
                :key="room">
                    {{ room }}
                </v-chip>
              </v-chip-group>
              </v-col>
            </v-row> -->
            <v-row class="my-3">
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-textarea
                    clear-icon="rounded-lg"
                    height="141"
                    :label="$t('landlord.aboutPropertyEn')"
                    v-model="variables.descriptionEn"
                    :error-messages="errors"
                    outlined
                    no-resize
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.aboutPropertyEn") }}
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-textarea
                    clear-icon="rounded-lg"
                    height="141"
                    v-model="variables.descriptionAr"
                    :label="$t('landlord.aboutPropertyAr')"
                    :error-messages="errors"
                    outlined
                    no-resize
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.aboutPropertyAr") }}
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card>
          <v-card
            flat
            class="rounded-lg pa-md-8 px-md-12 mb-12 mt-16"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <v-row class="">
              <v-col cols="12" sm="11" md="5" lg="4" class="py-0">
                <v-row v-for="(item, index) in fecilityCount" :key="index">
                  <v-col cols="5" sm="4" md="6">
                    <span class="d-block text-caption">{{ item.title }}</span>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <v-card
                      width="200"
                      elevation="0"
                      class="
                        rounded-lg
                        card-custom-border
                        d-flex
                        justify-space-around
                      "
                    >
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="subperson(item)" class="white--text"
                          >mdi-minus</v-icon
                        >
                      </div>
                      <span class="ma-2">{{ item.count }}</span>
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="addperson(item)" class="white--text"
                          >mdi-plus</v-icon
                        >
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" sm="4" class="mt-5" md="6">
                    <span class="text-caption">{{
                      $t("landlord.parking")
                    }}</span>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-start">
                    <v-checkbox
                      v-model="variables.isParkingAvailable"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" class="mb-16">
          <v-row>
            <v-col cols="12" md="6">
              <v-card
                @click="onClickImageUpload()"
                flat
                height="400px"
                class="
                  rounded-lg
                  card-custom-border
                  py-10
                  d-flex
                  justify-center
                  align-center
                "
              >
                <div>
                  <ValidationProvider
                    :rules="{
                      required: true,
                      maxSize: 8000
                    }"
                  >
                    <v-file-input
                      v-model="imageUpload"
                      v-show="false"
                      accept="image/*"
                      multiple
                      ref="imageUpload"
                      label="File input"
                    >
                      <template #label>
                        <span class="red--text"><strong>* </strong></span>File
                        input
                      </template></v-file-input
                    >
                    <v-img
                      class="mx-auto"
                      :src="require('@/assets/cameraUpload.png')"
                      width="50px"
                    ></v-img>
                    <p class="mt-5">
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("landlord.uploadPropertyUnitPhotos") }}
                    </p>
                    <div class="d-flex flex-column" style="gap: 5px;">
                      <v-btn
                        class="rounded-lg mx-auto white--text"
                        color="primary"
                        height="40px"
                        elevation="0"
                        width="200px"
                        >{{ $t("landlord.addPhotos") }}
                      </v-btn>
                      <span class="red--text text-caption mx-auto"
                        >*{{ $t("inputRules.fileLengthWarning") }}</span
                      >
                    </div>
                  </ValidationProvider>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="">
              <v-row class="" v-if="images.length <= 4">
                <v-col
                  class="py-0"
                  :cols="6"
                  v-for="(i, index) in images.length"
                  :key="i"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      @click="removeImage(index)"
                      flat
                      height="175"
                      class="card-custom-border rounded-lg mb-12 cursor-pointer"
                    >
                      <v-img height="100%" width="100%" :src="images[index]">
                      </v-img>

                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="primary">
                          <v-icon>mdi-close</v-icon>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>

              <v-row class="" v-else>
                <v-col
                  class="py-0"
                  :cols="4"
                  v-for="(i, index) in images.length"
                  :key="i"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card
                      @click="removeImage(index)"
                      flat
                      height="102"
                      class="card-custom-border rounded-lg mb-12 cursor-pointer"
                    >
                      <v-img height="100%" width="100%" :src="images[index]">
                      </v-img>

                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="primary">
                          <v-icon>mdi-close</v-icon>
                        </v-overlay>
                      </v-fade-transition>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-card
            flat
            class="rounded-lg pa-md-8 px-md-12 mb-12 mt-16"
            :class="$vuetify.breakpoint.mdAndUp ? 'card-custom-border' : ''"
          >
            <p class="text-h6 font-weight-bold">
              {{ $t("landlord.allowedFor") }}
            </p>
            <v-row class="">
              <v-col cols="12" md="6" lg="7" class="py-0 ms-md-10">
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{
                    $t("landlord.bachelorsAreWelcome")
                  }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox
                      v-model="variables.isBachelorAllowed"
                    ></v-checkbox>
                  </span>
                </div>
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{
                    $t("landlord.familiesAreWelcome")
                  }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox
                      v-model="variables.isFamillyAllowed"
                    ></v-checkbox>
                  </span>
                </div>
                <div class="text-caption d-flex align-center">
                  <span class="col-6 pa-0">{{ $t("landlord.pets") }}</span>
                  <span class="col-2 pa-0">
                    <v-checkbox v-model="variables.isPetAllowed"></v-checkbox>
                  </span>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="11"
                md="5"
                lg="4"
                class="py-0"
                v-if="variables.rentType === 'PER_DAY'"
              >
                <v-row v-for="(item, index) in peopleCount" :key="index">
                  <v-col cols="5" sm="4" md="6">
                    <span class="d-block text-caption">{{ item.title }}</span>
                    <span class="d-block text--disabled text-caption"
                      >({{ item.sub }})</span
                    >
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <v-card
                      width="200"
                      elevation="0"
                      class="
                        rounded-lg
                        card-custom-border
                        d-flex
                        justify-space-around
                      "
                    >
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="subperson(item)" class="white--text"
                          >mdi-minus</v-icon
                        >
                      </div>
                      <span class="ma-2">{{ item.count }}</span>
                      <div
                        class="
                          ma-2
                          text-h4
                          primary
                          custom-round-button
                          pa-2
                          d-flex
                          justify-center
                          align-center
                        "
                      >
                        <v-icon @click="addperson(item)" class="white--text"
                          >mdi-plus</v-icon
                        >
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                elevation="0"
                :width="$vuetify.breakpoint.smAndUp ? '300px' : '100%'"
                :loading="loading"
                height="45px"
                @click="goBack()"
                class="white--text font-weight-bold rounded-lg"
                color="primary"
              >
                {{ $t("core.back") }}
              </v-btn>
            </v-col>
            <v-col class="d-flex justify-right">
              <v-btn
                elevation="0"
                :width="$vuetify.breakpoint.smAndUp ? '300px' : '100%'"
                :loading="loading"
                height="45px"
                :disabled="!valid"
                color="primary"
                class="rounded-lg white--text font-weight-bold"
                @click="onSave"
              >
                {{ $t("landlord.addUnit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-snackbar :timeout="2000" v-model="snackBar" :color="snackColor">{{
        snackText
      }}</v-snackbar>
    </ValidationObserver>
  </v-card>
</template>

<script>
import moment from "moment";
import { createUnit } from "../../methods/create_unit";
import { compressImage } from "@/core/methods/compress_image";
import "@/core/methods/validation_rules";
export default {
  props: {
    landlordId: {
      type: String,
      required: true
    },
    totalNumberOfUnitsAllowed: {
      type: Number,
      required: true
    },
    propertyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      images: [],
      paymentCollectionDay: null,
      paymentCollectionDayMenu: false,
      imageUpload: null,
      successDialog: false,
      rentType: null,
      paymentCollectionDaytext: "-",
      arrayOfRooms: [],
      stringOfRooms: "",
      rerender: 0,
      isMaxNumberOfRoomsTaken: false,
      isRoomsDisabled: false,
      currentlyAddedRoomsCount: 0,
      variables: {
        images: [],
        property: null,
        numberOfUnits: 1,
        rentType: null
      },
      resetVariables: {
        images: [],
        nameEn: "",
        nameAr: "",
        unitType: "",
        floorArea: "",
        numberOfUnits: 1,
        descriptionEn: "",
        descriptionAr: "",
        oldRent: "",
        rent: ""
      },
      unitTypes: [],
      fecilityCount: [
        { title: this.$t("landlord.numberOfBedrooms"), count: 1, limit: 5 },
        { title: this.$t("landlord.numberOfBathrooms"), count: 1, limit: 5 },
        { title: this.$t("landlord.numberOfHalls"), count: 1, limit: 3 }
      ],
      peopleCount: [
        {
          title: this.$t("landlord.numberOfAdults"),
          sub: this.$t("landlord.age13orAbove"),
          count: 0,
          limit: 25
        },
        {
          title: this.$t("landlord.numberOfChildren"),
          sub: this.$t("landlord.age12"),
          count: 0,
          limit: 15
        },
        {
          title: this.$t("landlord.numberOfInfants"),
          sub: this.$t("landlord.under2"),
          count: 0,
          limit: 10
        }
      ],
      resetPeopleCount: [
        {
          title: this.$t("landlord.numberOfAdults"),
          sub: this.$t("landlord.age13orAbove"),
          count: 0,
          limit: 25
        },
        {
          title: this.$t("landlord.numberOfChildren"),
          sub: this.$t("landlord.age12"),
          count: 0,
          limit: 15
        },
        {
          title: this.$t("landlord.numberOfInfants"),
          sub: this.$t("landlord.under2"),
          count: 0,
          limit: 10
        }
      ],
      snackBar: false,
      snackColor: "",
      snackText: "",
      contracts: []
    };
  },
  created() {
    this.variables.property = this.propertyId;
    this.variables.rentType = "PER_MONTH";
    this.variables.landlordId = this.landlordId;
  },
  watch: {
    arrayOfRooms() {
      if (this.arrayOfRooms.length >= parseInt(this.variables.numberOfUnits)) {
        this.isMaxNumberOfRoomsTaken = true;
      } else {
        this.isMaxNumberOfRoomsTaken = false;
      }
    },
    stringOfRooms: {
      handler(roomString) {
        if (!this.arrayOfRooms.includes(roomString.split(",")[0])) {
          if (roomString && roomString.includes(",")) {
            const rooms = roomString.split(",");
            this.arrayOfRooms.push(rooms[0]);
            this.stringOfRooms = "";
          }
        }
      },
      immediate: true
    },
    paymentCollectionDay: {
      handler() {
        this.variables.paymentCollectionDay = parseInt(
          this.paymentCollectionDay
        );
        this.paymentCollectionDayMenu = false;
      }
    },

    imageUpload: {
      handler(images) {
        if (images && images.length) {
          images.map(val => {
            let noOfImages = this.images.length;
            this.images[noOfImages] = URL.createObjectURL(val);
            this.variables.images[noOfImages] = val;
          });
        }
      }
    }
  },
  methods: {
    goBack() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$root.$emit("refetchUnits");
    },
    validatePaymentDay(date) {
      if (date < 1 || date > 28) {
        return "Day Should Be Of 1-28";
      } else {
        return true;
      }
    },
    pushToRoomsArray() {
      if (this.stringOfRooms) {
        this.arrayOfRooms.push(this.stringOfRooms);
        return (this.stringOfRooms = "");
      }
    },
    checkIfRoomsExhausted(numberOfUnits) {
      const newCount = this.currentlyAddedRoomsCount + parseInt(numberOfUnits);
      const allowedUnitCount = this.totalNumberOfUnitsAllowed;
      if (newCount <= allowedUnitCount) {
        this.isRoomsDisabled = false;
        return true;
      } else {
        this.isRoomsDisabled = true;
        return "Total Units Should Not Exceed " + allowedUnitCount;
      }
    },
    removeRoomFromArray(room) {
      const newArray = [];
      this.arrayOfRooms.forEach(eachRoom => {
        if (room !== eachRoom) newArray.push(eachRoom);
      });
      this.arrayOfRooms = newArray;
    },
    isRoomNameAlreadyThere(room) {
      if (this.arrayOfRooms.includes(room)) {
        return false;
      }
      return true;
    },
    formatDate(date) {
      if (date) {
        return moment(new Date(parseInt(date))).format("MMM DD , YYYY");
      }
    },
    addperson(item) {
      if (item.count < item.limit) {
        item.count = item.count + 1;
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.limitReached");
      }
    },
    subperson(item) {
      if (item.count > 0) {
        item.count = item.count - 1;
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.atleastOneNeeded");
      }
    },
    onAddAnotherUnit() {
      this.successDialog = false;
      this.variables = {
        ...this.resetVariables,
        property: this.variables.property,
        rentType: this.variables.rentType
      };
      this.fecilityCount.forEach(fecility => {
        fecility.count = 1;
      });
      this.paymentCollectionDay = null;
      this.images = [];
      this.imageUpload = null;
      this.peopleCount = this.resetPeopleCount;
      this.arrayOfRooms = [];
      this.isMaxNumberOfRoomsTaken = false;
      this.$apollo.queries.getTotalRoomsUnderLandlord.refetch();
      this.rerender++;
    },
    onClickImageUpload() {
      this.$refs.imageUpload.$refs.input.click();
    },
    removeImage(index) {
      let image = this.images[index];
      this.images = this.images.filter(item => {
        return item !== image;
      });
      let img = this.variables.images[index];
      this.variables.images = this.variables.images.filter(item => {
        return item !== img;
      });
    },

    async onSave() {
      if (!this.images.length) {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.uploadAtleastOneImage");
        return false;
      }
      if (
        this.variables.numberOfUnits &&
        this.arrayOfRooms.length === parseInt(this.variables.numberOfUnits)
      ) {
        let roomString = "";
        this.arrayOfRooms.forEach((room, index) => {
          roomString += room;
          if (index !== this.arrayOfRooms.length - 1) {
            roomString += ",";
          }
        });
        this.variables.roomNumbers = roomString;
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.roomNumbersMissing");
        return false;
      }
      if (this.fecilityCount[0].count < 1 && this.fecilityCount[1].count < 1) {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("landlord.atleastOneRoom");
        return false;
      } else {
        this.variables.numberOfRooms = this.fecilityCount[0].count;
        this.variables.numberOfBathrooms = this.fecilityCount[1].count;
        this.variables.numberOfHalls = this.fecilityCount[2].count;
      }
      if (this.variables.rentType === "PER_DAY") {
        if (this.peopleCount[0].count < 1) {
          this.snackBar = true;
          this.snackColor = "error";
          this.snackText = this.$t("landlord.oneAdultNeeded");
          return false;
        } else {
          this.variables.adultCount = this.peopleCount[0].count;
          this.variables.childCount = this.peopleCount[1].count;
          this.variables.infantCount = this.peopleCount[2].count;
        }
      }
      this.variables.floorArea = parseFloat(this.variables.floorArea);
      this.variables.rent = parseFloat(this.variables.rent);
      this.variables.oldRent = parseFloat(this.variables.oldRent);
      this.variables.numberOfUnits = parseInt(this.variables.numberOfUnits);
      this.loading = true;
      // compress unit images
      this.variables.images = await Promise.all(
        this.variables.images.map(async image => await compressImage(image))
      );
      let response;
      try {
        response = await createUnit(this.variables);
      } catch (error) {
        this.$root.$emit("snackbar", {
          snackbar: true,
          text: this.$t("landlord.allowedUnitsExhausted"),
          color: "error"
        });
      }
      this.loading = false;
      if (response.data.createUnit) {
        if (response.data.createUnit._id) {
          this.successDialog = true;
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("landlord.unitAddedSuccessfully"),
            color: "success"
          });
          this.$root.$emit("refetchUnits");
          return this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
        }
      } else {
        this.snackBar = true;
        this.snackColor = "error";
        this.snackText = this.$t("snack.somethingWentWrong");
        return false;
      }
    }
  },
  apollo: {
    getUnitTypes() {
      return {
        query: require("@/landlord/api/queries/get_unit_types.graphql"),
        variables: { limit: 50, skip: 0 },
        result({ data }) {
          this.unitTypes = data.getUnitTypes.unitTypes;
        }
      };
    },
    getTotalRoomsUnderLandlordForAdmin() {
      return {
        query: require("@/landlord/api/queries/get_total_rooms_under_landlord.graphql"),
        variables: () => ({
          landlordId: this.landlordId
        }),
        fetchPolicy: "no-cache",
        result({ data }) {
          if (data.getTotalRoomsUnderLandlordForAdmin) {
            this.currentlyAddedRoomsCount = Number(
              data.getTotalRoomsUnderLandlordForAdmin
            );
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.card-custom-border {
  border: 1px solid #d8d7d7 !important;
}

.custom-round-button {
  height: 25px;
  width: 25px;
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
.custom-round-button-large {
  height: 45px;
  width: 45px;
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}
</style>
<style>
.v-text-field--full-width .v-input__prepend-outer,
.v-text-field--full-width .v-input__prepend-inner,
.v-text-field--full-width .v-input__append-inner,
.v-text-field--full-width .v-input__append-outer,
.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field--enclosed .v-input__append-inner,
.v-text-field--enclosed .v-input__append-outer {
  margin-top: 5px;
  margin-bottom: 5px;
}
.inputphone input[type="number"] {
  -moz-appearance: textfield;
}

.v-text-field--outlined .v-input__prepend-outer,
.v-text-field--outlined .v-input__append-outer {
  margin-top: 0px;
}
.inputphone input::-webkit-outer-spin-button,
.inputphone input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
